import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom';

import StickyBox from "react-sticky-box";

import axios from 'axios';

import { toggleFavorite } from '../../../redux/jewels/actions';

import classes from './JewelsDetails.module.scss';


class JewelsDetails extends Component {

    state = {
        item:null,
        nextitem:null,
        previtem:null
    }

    componentDidMount(){
        this.loadDetails();
    }

    componentDidUpdate(prevProps){
      if(this.props.match.params.jewelid!==prevProps.match.params.jewelid){
        this.loadDetails();
      }
    }

    loadDetails = () =>{
        const {jewelsState} = this.props;
        this.setState({
          item:null,
          nextitem:null,
          previtem:null
      });
        axios.get(`jewels/${this.props.match.params.jewelid}`, { params:{ length: jewelsState.length, start: (jewelsState.currentpage*jewelsState.length), filters:jewelsState.selectedfilters }}).then(res =>{
           this.setState({
                item:res.data.item,
                nextitem:res.data.nextitem,
                previtem:res.data.previtem
           });
        });
    }

    goBack = () => {
      this.props.history.push('/jewels/');
    }

    handleFavoriteClick = (markid) =>{
      this.props.toggleFavorite(markid);
    }



    render() {
        const tagsString = this.state.item && this.state.item.tags ? this.state.item.tags.join(" | "):'';
        return(
            <div className={classes.Container}>
            { this.state.item ?
            <Fragment>
            <div  className={classes.Images}>
               { this.state.item.images.map((image, index)=>( <img  alt="" key={index} src={image} /> )) }
            </div>
            <StickyBox  className={classes.Content}>
                <div className={classes.navconatainer}>
                  <div className={classes.buttoncontainer}><button className={classes.roundlink} onClick={()=>this.goBack()} ><img alt="" src={require('../../../assets/img/arrow-left.svg')} /></button></div>
                  <div className={classes.buttoncontainer}>{ this.state.previtem ? <NavLink className={classes.roundlink} to={`/jewels/${this.state.previtem}`}><img alt="" src={require('../../../assets/img/prev.svg')} /></NavLink>:<div className={[classes.roundlink, classes.disabled].join(" ")}><img alt="" src={require('../../../assets/img/prev.svg')} /></div> }</div>
                  <div className={classes.buttoncontainer}>{ this.state.nextitem ? <NavLink className={classes.roundlink} to={`/jewels/${this.state.nextitem}`}><img alt="" src={require('../../../assets/img/next.svg')} /></NavLink>:<div className={[classes.roundlink, classes.disabled].join(" ")}><img alt="" src={require('../../../assets/img/next.svg')} /></div> }</div>
                  <div className={classes.buttoncontainer}><button onClick={()=>this.handleFavoriteClick(this.state.item.id)} className={classes.roundlink}>{ this.props.favorites.find((element)=>{ return element === this.state.item.id; }) ? <img alt="" src={require('../../../assets/img/favorite_on.svg')} />:<img alt="" src={require('../../../assets/img/favorite_off.svg')} /> } </button></div>
                </div>
                <h3>{ this.state.item.surtitre }</h3>
                <h1>{ this.state.item.titre }</h1>
               
                { this.state.item.tags ? <Fragment>
                <h3>Tag{this.state.item.tags.length>1?"s":""}</h3>
                <p>{ tagsString }</p>
                </Fragment>:null }
               
                <div dangerouslySetInnerHTML={ { __html: this.state.item.content } }></div>
            </StickyBox></Fragment>
            : null }
            </div>
        );
    }
}


const mapStateToProps = (state)=>{
    return {
      jewelsState: state.jewels,
      favorites: state.jewels.favorites
    }
  };

export default connect(mapStateToProps, {toggleFavorite})(JewelsDetails);

